import React from 'react'
import { Navbar, Form, Footer } from '../components'

const Contact = () => {
  return (
    <div className="contact">
      <Navbar pageType="contact" />
      <Form />
      <Footer />
    </div>
  )
}

export default Contact
